module.exports = __webpack_public_path__ + "62f3f1f4.svg";